import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@salesforce/design-system-react/components/button';
import { IconSettings } from '@salesforce/design-system-react';

interface FreshInstallationTabProps {
    onSelectFreshPackages?: () => void;
}

/**
 * Body of the "Fresh Installation" inner tab, shown for partial fresh installations
 * (some packages installed, others missing): description, dependency note and a button to select packages.
 */
function CQFreshInstallationTab(props: FreshInstallationTabProps) {
    const { t } = useTranslation();

    return (
        <div className="slds-m-around_medium">
            <div className="slds-text-heading_small slds-text-align_left">
                <p className="">{t("fresh_installation_description")}</p>
                <div className="slds-notify slds-notify_alert slds-theme_alert-texture slds-theme_info slds-m-top_small" role="alert">
                    <svg className="slds-icon slds-icon_x-small slds-m-right_x-small" aria-hidden="true">
                        <use xlinkHref="/assets/icons/utility-sprite/svg/symbols.svg#info"></use>
                    </svg>
                    <span className="slds-text-body_regular">{t("fresh_installation_dependency_note")}</span>
                </div>
            </div>
            <div className="slds-m-top_medium slds-grid slds-grid_align-center">
                <IconSettings iconPath="/assets/icons">
                    <Button
                        variant="brand"
                        label={t("select_packages_to_install")}
                        disabled={!props.onSelectFreshPackages}
                        onClick={() => props.onSelectFreshPackages?.()}
                    />
                </IconSettings>
            </div>
        </div>
    );
}

export default CQFreshInstallationTab;
